import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { CERTIFICATES, certificatesUrl } from 'SharedDir/backend/endpoints/certificates';
import { UserCertificateBare, UserCertificateFull } from 'SharedDir/declarations/certificates';
import { AttachmentsBare } from 'SharedDir/declarations/departments';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class CertificatesApiClass extends SimpleApi<
  UserCertificateFull,
  never,
  never,
  UserCertificateBare
> {
  constructor() {
    super(certificatesUrl);
  }

  private readonly endpoints = CERTIFICATES;

  public async upload(file: File) {
    const endpoint = this.endpoints.STORE;

    const formData = new FormData();

    formData.append('file', file);

    const { data } = (await http({
      ...endpoint,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })) as AxiosResponse<UserCertificateFull>;

    return data;
  }

  public async signFile(userCertificateId: number, fileId: number) {
    const endpoint = this.endpoints.SIGN_FILE(userCertificateId);

    const { data } = (await http({
      ...endpoint,
      params: { fileId },
    })) as AxiosResponse<AttachmentsBare>;

    return data;
  }

  public async myCertificates<Extra extends object>(
    params: PaginationParams<Extra>
  ) {
    const endpoint = this.endpoints.ME;

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<Paginated<UserCertificateBare>>;

    return data;
  }
}
